import React from 'react';
import Container from 'common/source/components/UI/Container';

import CategoryGrid from 'common/source/containers/SPCategoryList';
import CatalogCategoryBodyWrapper from './catalogcategory.style';

const CatalogCategoryBody = ({ node }) => {
  const {
    html,
    frontmatter: { categories }
  } = node;
  return (
    <CatalogCategoryBodyWrapper>
      <CategoryGrid categories={categories} lastFeatured prefix="catalogo" />
      <Container>
        <div dangerouslySetInnerHTML={{ __html: html }} />
      </Container>
    </CatalogCategoryBodyWrapper>
  );
};

export default CatalogCategoryBody;
